export default __webpack_public_path__ + "static/media/me.39306906.jpg";